// CommitChart.js
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: ["data", "options"],
  methods: {
    init() {
      this.gradient = this.$refs.canvas
        .getContext("2d")
        .createLinearGradient(0, 0, 0, 450);

      this.gradient.addColorStop(0, "rgba(227, 77, 154, 0.8)");
      this.gradient.addColorStop(0.5, "rgba(227, 77, 154, 0.5)");
      this.gradient.addColorStop(1, "rgba(227, 77, 154, 0.2)");

      this.renderChart(
        {
          labels: this.data.arrDate,// ["", "", "", "", "", ""],
          datasets: [
            {
              label: ' ',//this.data.companyNames,
              borderColor: "#aa35cb",
              pointBackgroundColor: "white",
              borderWidth: 1.5,
              pointRadius: 5,
              pointBorderWidth: 2,
              pointBorderColor: "#b334c2",
              lineTension: 0,
              backgroundColor: this.gradient,
              data: this.data.smsCountValues,//[0, 15000, 11000, 36000, 33562, 70000]
            },
          ]
        },
        {
          legend: {
            // hides the legend
            display: false
          },
          tooltips: {
            backgroundColor: "#FFFFFF",
            bodyFontSize: 14,
            xPadding: 20,
            yPadding: 20,
            callbacks: {
              labelColor: function() {
                return {
                  borderColor: "#b334c2",
                  backgroundColor: "#b334c2"
                };
              },
              labelTextColor: function() {
                return "#55616E";
              },
              // label(tooltipItem, data) {
              //   // Get the dataset label.
                
              //   //const label = data.datasets[tooltipItem.datasetIndex].label;
              //   //const value = numeral(tooltipItem.yLabel).format('$0,0');
              //   let company_names = data.datasets[tooltipItem.datasetIndex].label;
              //   //console.log("aaa",company_names[1], '  --- ', tooltipItem.index)
              //   const label = company_names[tooltipItem.index];
      
              //   return ` ${label}`;
              // },
            }
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  display: false
                }
              }
            ],
            yAxes: [
              {
                gridLines: {
                  display: false
                },
                ticks: {
                  display: false
                }
              }
            ]
          }
        },
      );
    }
  },
  watch: {
    data(newData) {
      console.log("this.data", this.data)
      this.init(newData);
    }
  }
};
